import { render, staticRenderFns } from "./disadvantaged.vue?vue&type=template&id=4051e41a&"
import script from "./disadvantaged.vue?vue&type=script&lang=js&"
export * from "./disadvantaged.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports